<template>
  <custom-section id="brand" source="Navbar/Title"/>
</template>
<script>
  import CustomSection from './CustomSection';

  export default {
    components: {CustomSection},
  };
</script>
<style lang="scss">
  #brand {
    .logo {
      width: 3rem;
      height: 3rem;
      margin: -0.5rem 0;
    }

    .logo-alt {
      width: 2.5rem;
      height: 2.5rem;
      margin: -0.5rem 0;
    }
  }
</style>
